import { useHitUTMCount } from '~/lib/api/utm'
import { UTMTracker } from '~/utils/utmTracker'

export function useUTMTracking() {
  const route = useRoute()
  const tracker = new UTMTracker()
  const lastTrackedUTM = ref<Record<string, any> | null>(null)
  const allTrackedUTMs = ref<Record<string, any>>({})
  const { mutateAsync: useHitUTMCounting } = useHitUTMCount()
  const sendToAnalytics = async ({ utm }: { utm: string }) => {
    try {
      await useHitUTMCounting({ utm })
    }
    catch {
      console.error('Failed to send UTM data to server.')
    }
  }

  const refreshTracking = () => {
    allTrackedUTMs.value = tracker.getAllTrackedData()
  }

  const trackUTM = async () => {
    if (route.query.utm) {
      const utmParams = { ...route.query } as Record<string, string>
      const hasUTM = Object.values(utmParams).some(value => value !== null)

      if (hasUTM) {
        const result = await tracker.trackUTM(
          utmParams as any,
          sendToAnalytics,
        )

        if (result.tracked) {
          lastTrackedUTM.value = result.data ?? null
        }
        refreshTracking()
        return result
      }
    }
    return { tracked: false, reason: 'no_utm_params' }
  }

  const cleanup = () => {
    tracker.cleanupOldEntries()
    refreshTracking()
  }

  watch(
    () => route.fullPath,
    () => {
      trackUTM()
    },
    { deep: true },
  )

  onMounted(() => {
    trackUTM()
    refreshTracking()
    cleanup()
  })

  return {
    tracker,
    trackUTM,
    lastTrackedUTM,
    allTrackedUTMs,
    refreshTracking,
  }
}
